export default __webpack_public_path__ + "static/media/icon-internet-of-things.7d783f43.svg";